import React, { Component } from "react";
import AuthContext from "./AuthContext";
import { apiFetch } from "./utils";
export class AuthProvider extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isAuthenticated: false,
            isChecked: false,
            role: null,
            user: null,
            location: null,
            show: false
        };
    }

    componentDidMount() {
        this.validate();
    }
        
    toggleLoginModal = () => {
        this.setState({
            show: !this.state.show
        });
    }

    // Validate user session via backend (cookies)
    validate = async () => {
        try {
            const res = await apiFetch("auth/validate")
            if (res.ok) {
                const data = await res.json();
                this.setState({
                    isAuthenticated: true,
                    isChecked: true,
                    role: data.role,
                    user: data.user,
                    show: false,
                });
                return true;
                }

            // Not authenticated
            this.setState({ isAuthenticated: false, isChecked: true, role: null, user: null });
            return false;
        } catch {
            this.setState({ isAuthenticated: false, isChecked: true, role: null, user: null });
            return false;
        }
    };

    login = async () => {
        // With cookie-based flow, backend sets cookies on successful login
        // Frontend just fetches /validate to populate state
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (pos) => {
                    const location = {
                        lat: pos.coords.latitude,
                        lng: pos.coords.longitude,
                        accuracy: pos.coords.accuracy
                    };

                    // Store location in state or localStorage
                    this.setState({ location });
                    localStorage.setItem("loc_lat", location.lat);
                    localStorage.setItem("loc_lng", location.lng);
                    localStorage.setItem("loc_acc", location.accuracy);
                },
                () => {
                    // fail silently
                },
                { enableHighAccuracy: true }
            );
        }

        return this.validate();
    };

    logout = async () => {
        try {
            await apiFetch("auth/logout", {
                method: "POST"
            });
        } catch {
            // fail silently
        }
        this.setState({ isAuthenticated: false, role: null, user: null });
        window.location = "/";
    };

    render() {
        return (
            <AuthContext.Provider
                value={{
                    isAuthenticated: this.state.isAuthenticated,
                    isChecked: this.state.isChecked,
                    role: this.state.role,
                    user: this.state.user,
                    show: this.state.show,
                    login: this.login,
                    logout: this.logout,
                    validate: this.validate,
                    toggleLoginModal: this.toggleLoginModal
                }}
            >
                {this.props.children}
            </AuthContext.Provider>
        );
    }
}
